import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faExclamationCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";


export default class ModalAlertPanel extends Component {

  render() {

    const icon = (this.props.iconType === "error") ? <FontAwesomeIcon icon={faExclamationTriangle} color="red" size="2x" /> :
      (this.props.iconType === "warning") ? <FontAwesomeIcon icon={faExclamationCircle} color="yellow" size="2x" /> :
        <FontAwesomeIcon icon={faInfoCircle} color="green" size="2x" />;

    return (

      <div id="historyalert">

        <p>{this.props.title}</p>

        <div>
          {icon}&nbsp;{this.props.message}
        </div>

        <div style={{ width: "80%", display: "flex", justifyContent: "space-evenly", borderTop: "2px solid rgb(117, 161, 255, .7)", padding: "7px" }}>
          <Button onClick={(ev) => this.props.onCancel(ev)}>Close</Button>
        </div>
      </div>

    )
  }
}